import { defineMessages, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Heading } from '@homebotapp/hb-react-component-catalog'
import { AIR_DNA } from '../../../../constants'
import { fetchAirDna } from '../../../../actions/airDna'
import { selectRouteKey } from '../../../../store/selectors/routes'
import { BUYER_DIGEST_AIRDNA_MODULE } from '../../../../constants/tracking/trackingEventLocations/buyerDigestTrackingEventLocation'
import { HOMEOWNER_DIGEST_AIRDNA_MODULE } from '../../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'
import { ROUTE_KEY_BUY } from '../../../../constants/routes'
import { useCreateClientEvent } from '../../../../hooks'
import { useCallback } from 'react'
import { ClientEventSource } from '../../../../api/gqlaxy/gql/generated/graphql'
import { ClientEventName } from '../../../../api/gqlaxy/gql/generated/graphql'

export const MSG = defineMessages({
  sample: {
    id: 'AirDNA.trySampleAddress',
    defaultMessage: 'Try: {defaultAddress}'
  }
})

export interface AirDnaEmptyStateProps {
  stateKey: string
}

export const AirDnaEmptyState = ({ stateKey }: AirDnaEmptyStateProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const routeKey = useSelector(selectRouteKey)
  const { mutateAsync: createClientEvent } = useCreateClientEvent({ disableErrorPrompts: true })
  const addr = `${AIR_DNA.DEFAULT_ADDRESS.streetAddress}, ${AIR_DNA.DEFAULT_ADDRESS.city} ${AIR_DNA.DEFAULT_ADDRESS.state} ${AIR_DNA.DEFAULT_ADDRESS.zipcode}`

  const createUsedShortTermRentalsCalculatorEvent = useCallback(() => {
    createClientEvent({
      clientEventInput: {
        eventSource: ClientEventSource.Calculators,
        eventName: ClientEventName.UsedShortTermRentalCalculator
      }
    })
  }, [createClientEvent])

  const onSubmitExample = () => {
    createUsedShortTermRentalsCalculatorEvent()
    dispatch(
      fetchAirDna(stateKey, {
        address: AIR_DNA.DEFAULT_ADDRESS.streetAddress
      })
    )
  }

  return (
    <>
      <Heading as='h3' fontWeight='light' size='sm'>
        {intl.formatMessage(MSG.sample, {
          defaultAddress: (
            <Button
              size='sm'
              variant='ghost'
              colorScheme='primary'
              onClick={onSubmitExample}
              tracking={{
                guid: 'p4NuDkjJQJMSUhaoQbukxD',
                descriptor: addr,
                ui_context: routeKey === ROUTE_KEY_BUY ? BUYER_DIGEST_AIRDNA_MODULE : HOMEOWNER_DIGEST_AIRDNA_MODULE
              }}
            >
              {addr}
            </Button>
          )
        })}
      </Heading>
    </>
  )
}
